// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { dumpObj, fnApply } from "@nevware21/ts-utils";
import { _DYN_NOT_IMPLEMENTED, _DYN_WARN } from "../__DynamicConstants";
/**
 * Handle / report an error.
 * When not provided the default is to generally throw an {@link OTelInvalidAttributeError}
 * @param handlers - The error handlers configuration
 * @param message - The error message to report
 * @param key - The attribute key that caused the error
 * @param value - The attribute value that caused the error
 */
/*#__NO_SIDE_EFFECTS__*/
export function handleAttribError(handlers, message, key, value) {
    if (handlers.attribError) {
        handlers.attribError(message, key, value);
    }
    else {
        handleWarn(handlers, message + " for [" + key + "]: " + dumpObj(value));
    }
}
/**
 * There was an error with the span.
 * @param handlers - The error handlers configuration
 * @param message - The message to report
 * @param spanName - The name of the span
 */
/*#__NO_SIDE_EFFECTS__*/
export function handleSpanError(handlers, message, spanName) {
    if (handlers.spanError) {
        handlers.spanError(message, spanName);
    }
    else {
        handleWarn(handlers, "Span [" + spanName + "]: " + message);
    }
}
/**
 * Report a general debug message, should not be treated as fatal
 * @param handlers - The error handlers configuration
 * @param message - The debug message to report
 */
/*#__NO_SIDE_EFFECTS__*/
export function handleDebug(handlers, message) {
    if (handlers.debug) {
        handlers.debug(message);
    }
    else {
        if (console) {
            var fn = console.log;
            fnApply(fn, console, [message]);
        }
    }
}
/**
 * Report a general warning, should not be treated as fatal
 * @param handlers - The error handlers configuration
 * @param message - The warning message to report
 */
/*#__NO_SIDE_EFFECTS__*/
export function handleWarn(handlers, message) {
    if (handlers[_DYN_WARN /* @min:%2ewarn */]) {
        handlers[_DYN_WARN /* @min:%2ewarn */](message);
    }
    else {
        if (console) {
            var fn = console[_DYN_WARN /* @min:%2ewarn */] || console.log;
            fnApply(fn, console, [message]);
        }
    }
}
/**
 * Report a general error, should not be treated as fatal
 * @param handlers - The error handlers configuration
 * @param message - The error message to report
 */
/*#__NO_SIDE_EFFECTS__*/
export function handleError(handlers, message) {
    if (handlers.error) {
        handlers.error(message);
    }
    else if (handlers[_DYN_WARN /* @min:%2ewarn */]) {
        handlers[_DYN_WARN /* @min:%2ewarn */](message);
    }
    else {
        if (console) {
            var fn = console.error || console[_DYN_WARN /* @min:%2ewarn */] || console.log;
            fnApply(fn, console, [message]);
        }
    }
}
/**
 * A general error handler for not implemented methods.
 * @param handlers - The error handlers configuration
 * @param message - The message to report
 */
/*#__NO_SIDE_EFFECTS__*/
export function handleNotImplemented(handlers, message) {
    if (handlers[_DYN_NOT_IMPLEMENTED /* @min:%2enotImplemented */]) {
        handlers[_DYN_NOT_IMPLEMENTED /* @min:%2enotImplemented */](message);
    }
    else {
        if (console) {
            var fn = console.error || console.log;
            fnApply(fn, console, [message]);
        }
    }
}
//# sourceMappingURL=handleErrors.js.map